import "./hb-platinum.module.css";
import { html } from "lit-html";
import { getUsername } from "../../../global";

export default (user) => html`
    <form id="hb-platinum" class="hidden space-y-4 pb-0">
        <p
            class="hidden mt-5 mb-3 text-center text-sm font-medium text-gray-500 dark:text-gray-400">
            <strong>$300</strong> Store Credits Per Month
        </p>
        <p
            class="mt-5 mb-3 text-center text-sm font-medium text-gray-500 dark:text-gray-400">
            By <strong>Invitation Only</strong> Based on Your Aura
        </p>
        <div
            class="w-full max-w-full p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:p-8 dark:bg-gray-800 dark:border-gray-700">
            <h5
                class="mb-4 text-xl font-medium text-gray-500 dark:text-gray-400">
                Heart of Platinum ℹ️
            </h5>
            <div class="flex items-baseline text-gray-900 dark:text-white">
                <span class="text-3xl font-semibold">$</span>
                <span class="text-5xl font-extrabold tracking-tight">0</span>
                <span
                    class="ms-1 text-xl font-normal text-gray-500 dark:text-gray-400"
                    >USD / month</span
                >
            </div>
            <ul role="list" class="space-y-5 my-7">
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        >Everything in <strong>Heart of Gold</strong></span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        ><strong>Purple Platinum Aura</strong> around your
                        Beating Heart</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        >Create Organizations with
                        <strong>Verified Aura Ring</strong></span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3">
                        <strong>Unlimited Advertising</strong> based on your
                        Organization's Aura Ring
                    </span>
                </li>
                <li class="hidden items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        ><strong>$300 Advertising Credits</strong> per
                        Month</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3">
                        Create <strong>Unlimited Custom B-Stamps</strong> to
                        engrave on your products
                    </span>
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3">
                        List your products on
                        <strong>HeartBank® Treasure Island</strong>
                        (online marketplace)
                    </span>
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3">
                        Join <strong>HeartBank® CEO Club</strong> to receive
                        funding and mentorship
                    </span>
                </li>
                <li class="hidden items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        ><strong>10% Platinum Member Discount</strong> Off All
                        Purchases of Virtual B-Bills</span
                    >
                </li>
                <li class="hidden items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        ><strong>Enterprise</strong> Capricorn AI with Chat,
                        Voice, and Vision</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        ><strong>Enterprise Capricorn AI</strong> with Voice,
                        Image, Video, and Code Generation</span
                    >
                </li>
                <li class="flex items-center">
                    <svg
                        class="shrink-0 w-4 h-4 text-blue-700 dark:text-blue-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20">
                        <path
                            d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                    </svg>
                    <span
                        class="text-base font-normal leading-tight text-gray-500 dark:text-gray-400 ms-3"
                        ><strong>Dedicated</strong> Human Support via X Chat or
                        WhatsApp Chat</span
                    >
                </li>
            </ul>
            <a
                href2="#/phone"
                class="inline-flex text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-200 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-900 font-medium rounded-lg text-sm px-5 py-2.5 justify-center w-full text-center">
                Verify Your Family Tree
            </a>
        </div>
        <p
            class="mt-[-5px] text-center text-xs font-medium text-gray-500 dark:text-gray-500">
            <a href="#/about/terms"
                >Our mission is to invite all of humanity to create
                <strong>one global family</strong> ℹ️</a
            >
        </p>
        <br />
        <div class="hidden">
            <label
                for="hb-platinum-username"
                class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Your Full Legal Name
            </label>
            <section class="inline-flex w-full justify-between">
                <input
                    type="text"
                    autocomplete="off"
                    id="hb-platinum-username"
                    class="bg-gray-50 outline-0 border border-gray-300 text-gray-900 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full mr-1 p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    placeholder="Enter Full Legal Name" />
                <button
                    id="hb-platinum-username-btn"
                    type="button"
                    class="text-black dark:text-white bg-logo dark:bg-logo-dark cursor-pointer focus:ring-4 focus:outline-none focus:ring-logo/25 font-medium rounded-lg text-sm px-4 py-2 text-center">
                    Update
                </button>
            </section>
        </div>
        <div class="hidden">
            <label
                for="hb-platinum-number"
                class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Your Legal Last Name
            </label>
            <section class="inline-flex w-full justify-between">
                <input
                    type="text"
                    autocomplete="off"
                    id="hb-platinum-number"
                    class="bg-gray-50 border outline-0 border-gray-300 text-gray-900 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full mr-1 p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    placeholder="${user?.phoneNumber
                        ? user.phoneNumber
                        : "+180059THANK"}"
                    disabled />
                <button
                    id="hb-platinum-number-btn"
                    type="button"
                    class="text-black dark:text-white bg-logo dark:bg-logo-dark cursor-pointer focus:ring-4 focus:outline-none focus:ring-logo/25 font-medium rounded-lg text-sm px-4 py-2 text-center">
                    Remove
                </button>
            </section>
        </div>
    </form>
`;
